// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../assets/fonts/Thicker-Regular.otf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("../../assets/fonts/Thicker-Extralight.otf", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@font-face {
  font-family: regularThicker;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
}

@font-face {
  font-family: lightThicker;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_1___});
}


.about_wrapper {
  width: 100%;
  position: relative;
}

.about_main_div {
  width: 100%;
  background-color: #fff !important;
}

.about_info_main_div {
  max-width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
}

.about_info_div {
  width: 100%;
  padding: 0 80px;
}

.about_info_div > p {
  color: #000;
  font-family: regularThicker;
  font-size: 20px;
  font-style: normal;
  font-weight: 400;
  line-height: 150%;
  margin: 30px 0 45px 0;
}

/* card styling start here ------------------------------------------------ */

.about_logo_card_div {
  width: 100%;
  height: 100%;
  background: #262626;
  display: flex;
  align-items: center;
  justify-content: center;
  position: sticky;
  top: 0;
}

.about_logo_card {
  width: 1443px;
  height: 600px;
  padding: 0 80px !important;
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-direction: row;
}

.about_logo_card_left {
  width: 50%;
  height: 100%;
}

.about_logo_card_left_inner {
  height: 100%;
  padding: 0px 40px 0px 0;
  display: flex;
  /* align-items: center; */
  justify-content: center;
  flex-direction: column;
  overflow: auto;
}

.about_card_div {
  width: 100%;
  height: 100%;
  background: #262626;
  display: flex;
  align-items: center;
  justify-content: center;
  position: sticky;
  top: 0;
}

.about_card {
  width: 1443px;
  height: 600px;
  padding: 0 80px !important;
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-direction: row;
}

.about_card_left {
  width: 50%;
  height: 100%;
}

.about_card_left_inner {
  height: 100%;
  padding: 0px 40px 0px 0;
  display: flex;
  justify-content: center;
  flex-direction: column;
  overflow: auto;
}

.about_card_left_heading {
  color: #fff;
  font-family: regularThicker;
  font-size: 32px;
  font-style: normal;
  font-weight: 600;
  line-height: 126.6%; /* 40.512px */
  margin: 0 0 6px 0 !important;
}

.about_card_heading_border {
  width: 114px;
  height: 4px;
  background: #ba1e24;
  margin: 0 0 16px 0;
}

.about_card_left_para {
  color: #fff;
  font-family: lightThicker !important;
  font-size: 20px;
  font-style: normal;
  font-weight: 400;
  line-height: 150%; /* 27px */
}

.about_card_right {
  width: 50%;
  height: 100%;
}

.about_card_right > img {
  width: 100%;
  height: 100%;
  object-fit: fill;
}

.about_card_div2 {
  width: 100%;
  height: 100%;
  background: white;
  display: flex;
  align-items: center;
  justify-content: center;
  position: sticky;
  top: 0;
}

.about_card2 {
  width: 1443px;
  height: 600px;
  padding: 0 80px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-direction: row;
}

.about_card_left2 {
  width: 50%;
  height: 100%;
}

.about_card_left_inner2 {
  height: 100%;
  padding-left: 70px;
  display: flex;
  justify-content: center;
  flex-direction: column;
}

.about_card_left_heading2 {
  color: #000;
  font-family: regularThicker;
  font-size: 32px;
  font-style: normal;
  font-weight: 600;
  line-height: 126.6%;
  margin: 0 0 6px 0 !important;
}

.about_card_heading_border2 {
  width: 114px;
  height: 4px;
  background: #ba1e24;
  margin: 0 0 16px 0;
}

.about_card_left_para2 {
  color: #000;
  font-family: lightThicker !important;
  font-size: 20px;
  font-style: normal;
  font-weight: 400;
  line-height: 150%; /* 27px */
}

.about_card_right2 {
  width: 50%;
  height: 100%;
}

.about_card_right2 > img {
  width: 100%;
  height: 100%;
  object-fit: fill;
}

.about_card_link {
  color: #ba1e24;
  font-family: regularThicker;
  font-size: 18px;
  font-style: normal;
  font-weight: 400;
  line-height: 150%;
}

.about_card_show_more_btn {
  color: #ba1e24;
  font-family: regularThicker;
  font-size: 18px;
  font-style: normal;
  font-weight: 600;
  /* line-height: 150%; */
  background: none;
  border: none;
  margin-left: 5px;
  cursor: pointer;
}






@media screen and (max-width: 1200px) {

  .about_info_main_div {
    max-width: 100%;
  }

  .about_info_div {
    width: 100%;
    width: 100%;
    padding: 0 50px;
  }

  .about_info_div > p {
    font-size: 20px;
    margin: 30px 0 30px 0;
  }

  /* card styling start here ------------------------------------------------ */
  
  .about_logo_card {
    width: 100%;
    height: 500px;
    padding: 0 50px !important;
  }
  
  .about_logo_card_left {
    width: 50%;
    height: 100%;
  }
  
  .about_logo_card_left_inner {
    height: 100%;
    padding: 0px 30px 0px 0;
  }


  .about_card_div {
    width: 100%;
    height: 100%;
  }

  .about_card {
    width: 100%;
    height: 500px;
    padding: 0 !important;
    justify-content: space-between;
    flex-direction: row;
  }

  .about_card_left {
    width: 50%;
    height: 100%;
  }

  .about_card_left_inner {
    padding: 50px 20px;
    height: 100% !important;
    justify-content: flex-start;
  }

  .about_card_left_heading {
    font-size: 30px;
    margin: 0 0 6px 0 !important;
  }

  .about_card_heading_border {
    width: 100px;
    height: 4px;
    margin: 10px 0 10px 0;
  }

  .about_card_left_para {
    font-size: 18px;
  }

  .about_card_right {
    width: 50%;
    height: 100%;
  }

  .about_card_right > img {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }

  .about_card_div2 {
    width: 100%;
    height: 100%;
  }

  .about_card2 {
    width: 100%;
    height: 500px;
    padding: 0;
    justify-content: space-between;
    flex-direction: row;
  }

  .about_card_left2 {
    width: 50%;
    height: 100%;
  }

  .about_card_left_inner2 {
    padding: 50px 20px;
    justify-content: flex-start;
  }

  .about_card_left_heading2 {
    font-size: 30px;
    margin: 0 0 6px 0 !important;

  }

  .about_card_heading_border2 {
    width: 100px;
    height: 4px;
    margin: 0 0 10px 0;
  }

  .about_card_left_para2 {
    font-size: 18px;
  }

  .about_card_right2 {
    width: 50%;
    height: 100%;
  }

  .about_card_right2 > img {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }

  .about_card_link {
    font-size: 16px;
  }

}









@media screen and (max-width: 1024px) {

  .about_info_main_div {
    max-width: 100%;
  }

  .about_info_div {
    width: 100%;
    width: 100%;
    padding: 0 40px;
  }

  .about_info_div > p {
    font-size: 20px;
    line-height: 26px;
    margin: 30px 0 30px 0;
  }

  /* card styling start here ------------------------------------------------ */

  .about_logo_card {
    width: 100%;
    height: 400px;
    padding: 0 50px !important;
  }
  
  .about_logo_card_left {
    width: 50%;
    height: 100%;
  }
  
  .about_logo_card_left_inner {
    height: 100%;
    padding: 0px 20px 0px 0;
  }

  .about_card_div {
    width: 100%;
    height: 100%;
  }

  .about_card {
    width: 100%;
    height: 400px;
    padding: 0 !important;
    justify-content: space-between;
    flex-direction: row;
  }

  .about_card_left {
    width: 50%;
    height: 100%;
  }

  .about_card_left_inner {
    height: 100%;
    padding: 40px 20px;
    overflow: auto;
  }

  .about_card_left_heading {
    font-size: 26px;
  }

  .about_card_heading_border {
    width: 80px;
    height: 4px;
    margin: 0 0 10px 0;
  }

  .about_card_left_para {
    font-size: 16px;
  }

  .about_card_right {
    width: 50%;
    height: 100%;
  }

  .about_card_right > img {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }

  .about_card_div2 {
    width: 100%;
    height: 100%;
  }

  .about_card2 {
    width: 100%;
    height: 400px;
    padding: 0;
    justify-content: space-between;
    flex-direction: row;
  }

  .about_card_left2 {
    width: 50%;
    height: 100%;
  }

  .about_card_left_inner2 {
    height: 100%;
    padding: 40px 20px;
    overflow: auto;
  }

  .about_card_left_heading2 {
    font-size: 26px;
  }

  .about_card_heading_border2 {
    width: 80px;
    height: 4px;
    margin: 0 0 10px 0;
  }

  .about_card_left_para2 {
    font-size: 16px;
  }

  .about_card_right2 {
    width: 50%;
    height: 100%;
  }

  .about_card_right2 > img {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }

  .about_card_link {
    font-size: 16px;
  }

}













@media screen and (max-width: 800px) {

  .about_info_main_div {
    max-width: 100%;
  }

  .about_info_div {
    width: 100%;
    width: 100%;
    padding: 0 30px;
  }

  .about_info_div > p {
    font-size: 20px;
    line-height: 26px;
    margin: 20px 0 20px 0;
  }

  /* card styling start here ------------------------------------------------ */

  .about_logo_card {
    width: 100%;
    height: 100%;
    padding: 0 0 0 30px !important;
    flex-direction: column;
  }
  
  .about_logo_card_left {
    width: 100%;
    height: 100%;
  }
  
  .about_logo_card_left_inner {
    height: 100%;
    padding: 20px;
  }

  .about_card_logo_img {
    width: 500px !important;
    height: 500px !important;
  }

  .about_card_div {
    width: 100%;
    height: 100%;
  }

  .about_card {
    width: 100%;
    height: 100%;
    padding: 0 !important;
    justify-content: space-between;
    flex-direction: column;
  }

  .about_card_left {
    width: 100%;
    height: 100%;
  }

  .about_card_left_inner {
    height: 100%;
    padding: 40px 20px;
    overflow: auto;
  }

  .about_card_left_heading {
    font-size: 26px;
  }

  .about_card_heading_border {
    width: 80px;
    height: 4px;
    margin: 0 0 10px 0;
  }

  .about_card_left_para {
    font-size: 16px;
  }

  .about_card_right {
    width: 100%;
    height: 500px;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .about_card_right > img {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }

  .about_card_div2 {
    width: 100%;
    height: 100%;
  }

  .about_card2 {
    width: 100%;
    height: 100%;
    padding: 0;
    justify-content: space-between;
    flex-direction: column-reverse;
  }

  .about_card_left2 {
    width: 100%;
    height: 100%;
  }

  .about_card_left_inner2 {
    height: 100%;
    padding: 40px 20px;
    overflow: auto;
  }

  .about_card_left_heading2 {
    font-size: 26px;
  }

  .about_card_heading_border2 {
    width: 80px;
    height: 4px;
    margin: 0 0 10px 0;
  }

  .about_card_left_para2 {
    font-size: 16px;
  }

  .about_card_right2 {
    width: 100%;
    height: 500px;
  }

  .about_card_right2 > img {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }

  .about_card_link {
    font-size: 16px;
  }

}













@media screen and (max-width: 600px) {

  .about_info_main_div {
    max-width: 100%;
  }

  .about_info_div {
    width: 100%;
    width: 100%;
    padding: 0 20px;
  }

  .about_info_div > p {
    font-size: 16px;
    line-height: 22px;
    margin: 20px 0 20px 0;
  }

  /* card styling start here ------------------------------------------------ */

  .about_logo_card {
    width: 100%;
    height: 100%;
    padding: 0 !important;
    flex-direction: column;
  }
  
  .about_logo_card_left {
    width: 100%;
    height: 100%;
  }
  
  .about_logo_card_left_inner {
    height: 100%;
    padding: 20px;
  }

  .about_card_logo_img {
    width: 400px !important;
    height: 400px !important;
  }

  .about_card_div {
    width: 100%;
    height: 100%;
  }

  .about_card {
    width: 100%;
    height: 100%;
    padding: 0 !important;
    justify-content: space-between;
    flex-direction: column;
  }

  .about_card_left {
    width: 100%;
    height: 100%;
  }

  .about_card_left_inner {
    height: 100%;
    padding: 40px 20px 0 20px;
    overflow: auto;
  }

  .about_card_left_heading {
    font-size: 26px;
  }

  .about_card_heading_border {
    width: 80px;
    height: 4px;
    margin: 0 0 10px 0;
  }

  .about_card_left_para {
    font-size: 16px;
  }

  .about_card_right {
    width: 100%;
    height: 400px;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .about_card_right > img {
    width: 100%;
    height: 400px;
    object-fit: cover;
  }

  .about_card_div2 {
    width: 100%;
    height: 100%;
  }

  .about_card2 {
    width: 100%;
    height: 100%;
    padding: 0;
    justify-content: space-between;
    flex-direction: column-reverse;
  }

  .about_card_left2 {
    width: 100%;
    height: 100%;
  }

  .about_card_left_inner2 {
    height: 100%;
    padding: 40px 20px 0 20px;
    overflow: auto;
  }

  .about_card_left_heading2 {
    font-size: 26px;
  }

  .about_card_heading_border2 {
    width: 80px;
    height: 4px;
    margin: 0 0 10px 0;
  }

  .about_card_left_para2 {
    font-size: 16px;
  }

  .about_card_right2 {
    width: 100%;
    height: 400px;
  }

  .about_card_right2 > img {
    width: 100%;
    height: 400px;
    object-fit: cover;
  }

  .about_card_link {
    font-size: 16px;
  }

}












@media screen and (max-width: 450px) {

  .about_info_main_div {
    max-width: 100%;
  }

  .about_info_div {
    width: 100%;
    width: 100%;
    padding: 0 16px;
  }

  .about_info_div > p {
    font-size: 16px;
    line-height: 22px;
    margin: 20px 0 20px 0;
  }

  /* card styling start here ------------------------------------------------ */

  .about_logo_card {
    width: 100%;
    height: 100%;
    padding: 0 !important;
    flex-direction: column;
  }
  
  .about_logo_card_left {
    width: 100%;
    height: 100%;
  }
  
  .about_logo_card_left_inner {
    height: 100%;
    padding: 20px 20px 0 20px;
  }

  .about_card_logo_img {
    width: 400px !important;
    height: 400px !important;
  }

  .about_card_div {
    width: 100%;
    height: 100%;
  }

  .about_card {
    width: 100%;
    height: 100%;
    padding: 0 !important;
    justify-content: space-between;
    flex-direction: column;
  }

  .about_card_left {
    width: 100%;
    height: 100%;
  }

  .about_card_left_inner {
    height: 100%;
    padding: 40px 20px 0 20px;
    overflow: auto;
  }

  .about_card_left_heading {
    font-size: 26px;
  }

  .about_card_heading_border {
    width: 80px;
    height: 4px;
    margin: 0 0 10px 0;
  }

  .about_card_left_para {
    font-size: 16px;
  }

  .about_card_right {
    width: 100%;
    height: 350px;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .about_card_right > img {
    width: 100%;
    height: 350px;
    object-fit: cover;
  }

  .about_card_div2 {
    width: 100%;
    height: 100%;
  }

  .about_card2 {
    width: 100%;
    height: 100%;
    padding: 0;
    justify-content: space-between;
    flex-direction: column-reverse;
  }

  .about_card_left2 {
    width: 100%;
    height: 100%;
  }

  .about_card_left_inner2 {
    height: 100%;
    padding: 60px 20px 0 20px;
    overflow: auto;
  }

  .about_card_left_heading2 {
    font-size: 26px;
  }

  .about_card_heading_border2 {
    width: 80px;
    height: 4px;
    margin: 0 0 10px 0;
  }

  .about_card_left_para2 {
    font-size: 16px;
  }

  .about_card_right2 {
    width: 100%;
    height: 350px;
  }

  .about_card_right2 > img {
    width: 100%;
    height: 350px;
    object-fit: cover;
  }

  .about_card_link {
    font-size: 16px;
  }

}`, "",{"version":3,"sources":["webpack://./src/components/aboutUs/aboutus.css"],"names":[],"mappings":"AAAA;EACE,2BAA2B;EAC3B,4CAAgD;AAClD;;AAEA;EACE,yBAAyB;EACzB,4CAAmD;AACrD;;;AAGA;EACE,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,iCAAiC;AACnC;;AAEA;EACE,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,2BAA2B;EAC3B,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;EACjB,qBAAqB;AACvB;;AAEA,6EAA6E;;AAE7E;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,gBAAgB;EAChB,MAAM;AACR;;AAEA;EACE,aAAa;EACb,aAAa;EACb,0BAA0B;EAC1B,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE,UAAU;EACV,YAAY;AACd;;AAEA;EACE,YAAY;EACZ,uBAAuB;EACvB,aAAa;EACb,yBAAyB;EACzB,uBAAuB;EACvB,sBAAsB;EACtB,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,gBAAgB;EAChB,MAAM;AACR;;AAEA;EACE,aAAa;EACb,aAAa;EACb,0BAA0B;EAC1B,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE,UAAU;EACV,YAAY;AACd;;AAEA;EACE,YAAY;EACZ,uBAAuB;EACvB,aAAa;EACb,uBAAuB;EACvB,sBAAsB;EACtB,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,2BAA2B;EAC3B,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB,EAAE,aAAa;EAClC,4BAA4B;AAC9B;;AAEA;EACE,YAAY;EACZ,WAAW;EACX,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,oCAAoC;EACpC,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB,EAAE,SAAS;AAC9B;;AAEA;EACE,UAAU;EACV,YAAY;AACd;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,gBAAgB;EAChB,MAAM;AACR;;AAEA;EACE,aAAa;EACb,aAAa;EACb,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE,UAAU;EACV,YAAY;AACd;;AAEA;EACE,YAAY;EACZ,kBAAkB;EAClB,aAAa;EACb,uBAAuB;EACvB,sBAAsB;AACxB;;AAEA;EACE,WAAW;EACX,2BAA2B;EAC3B,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;EACnB,4BAA4B;AAC9B;;AAEA;EACE,YAAY;EACZ,WAAW;EACX,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,oCAAoC;EACpC,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB,EAAE,SAAS;AAC9B;;AAEA;EACE,UAAU;EACV,YAAY;AACd;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,2BAA2B;EAC3B,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,cAAc;EACd,2BAA2B;EAC3B,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,uBAAuB;EACvB,gBAAgB;EAChB,YAAY;EACZ,gBAAgB;EAChB,eAAe;AACjB;;;;;;;AAOA;;EAEE;IACE,eAAe;EACjB;;EAEA;IACE,WAAW;IACX,WAAW;IACX,eAAe;EACjB;;EAEA;IACE,eAAe;IACf,qBAAqB;EACvB;;EAEA,6EAA6E;;EAE7E;IACE,WAAW;IACX,aAAa;IACb,0BAA0B;EAC5B;;EAEA;IACE,UAAU;IACV,YAAY;EACd;;EAEA;IACE,YAAY;IACZ,uBAAuB;EACzB;;;EAGA;IACE,WAAW;IACX,YAAY;EACd;;EAEA;IACE,WAAW;IACX,aAAa;IACb,qBAAqB;IACrB,8BAA8B;IAC9B,mBAAmB;EACrB;;EAEA;IACE,UAAU;IACV,YAAY;EACd;;EAEA;IACE,kBAAkB;IAClB,uBAAuB;IACvB,2BAA2B;EAC7B;;EAEA;IACE,eAAe;IACf,4BAA4B;EAC9B;;EAEA;IACE,YAAY;IACZ,WAAW;IACX,qBAAqB;EACvB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,UAAU;IACV,YAAY;EACd;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,iBAAiB;EACnB;;EAEA;IACE,WAAW;IACX,YAAY;EACd;;EAEA;IACE,WAAW;IACX,aAAa;IACb,UAAU;IACV,8BAA8B;IAC9B,mBAAmB;EACrB;;EAEA;IACE,UAAU;IACV,YAAY;EACd;;EAEA;IACE,kBAAkB;IAClB,2BAA2B;EAC7B;;EAEA;IACE,eAAe;IACf,4BAA4B;;EAE9B;;EAEA;IACE,YAAY;IACZ,WAAW;IACX,kBAAkB;EACpB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,UAAU;IACV,YAAY;EACd;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,iBAAiB;EACnB;;EAEA;IACE,eAAe;EACjB;;AAEF;;;;;;;;;;AAUA;;EAEE;IACE,eAAe;EACjB;;EAEA;IACE,WAAW;IACX,WAAW;IACX,eAAe;EACjB;;EAEA;IACE,eAAe;IACf,iBAAiB;IACjB,qBAAqB;EACvB;;EAEA,6EAA6E;;EAE7E;IACE,WAAW;IACX,aAAa;IACb,0BAA0B;EAC5B;;EAEA;IACE,UAAU;IACV,YAAY;EACd;;EAEA;IACE,YAAY;IACZ,uBAAuB;EACzB;;EAEA;IACE,WAAW;IACX,YAAY;EACd;;EAEA;IACE,WAAW;IACX,aAAa;IACb,qBAAqB;IACrB,8BAA8B;IAC9B,mBAAmB;EACrB;;EAEA;IACE,UAAU;IACV,YAAY;EACd;;EAEA;IACE,YAAY;IACZ,kBAAkB;IAClB,cAAc;EAChB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,WAAW;IACX,WAAW;IACX,kBAAkB;EACpB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,UAAU;IACV,YAAY;EACd;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,iBAAiB;EACnB;;EAEA;IACE,WAAW;IACX,YAAY;EACd;;EAEA;IACE,WAAW;IACX,aAAa;IACb,UAAU;IACV,8BAA8B;IAC9B,mBAAmB;EACrB;;EAEA;IACE,UAAU;IACV,YAAY;EACd;;EAEA;IACE,YAAY;IACZ,kBAAkB;IAClB,cAAc;EAChB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,WAAW;IACX,WAAW;IACX,kBAAkB;EACpB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,UAAU;IACV,YAAY;EACd;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,iBAAiB;EACnB;;EAEA;IACE,eAAe;EACjB;;AAEF;;;;;;;;;;;;;;AAcA;;EAEE;IACE,eAAe;EACjB;;EAEA;IACE,WAAW;IACX,WAAW;IACX,eAAe;EACjB;;EAEA;IACE,eAAe;IACf,iBAAiB;IACjB,qBAAqB;EACvB;;EAEA,6EAA6E;;EAE7E;IACE,WAAW;IACX,YAAY;IACZ,8BAA8B;IAC9B,sBAAsB;EACxB;;EAEA;IACE,WAAW;IACX,YAAY;EACd;;EAEA;IACE,YAAY;IACZ,aAAa;EACf;;EAEA;IACE,uBAAuB;IACvB,wBAAwB;EAC1B;;EAEA;IACE,WAAW;IACX,YAAY;EACd;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,qBAAqB;IACrB,8BAA8B;IAC9B,sBAAsB;EACxB;;EAEA;IACE,WAAW;IACX,YAAY;EACd;;EAEA;IACE,YAAY;IACZ,kBAAkB;IAClB,cAAc;EAChB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,WAAW;IACX,WAAW;IACX,kBAAkB;EACpB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,WAAW;IACX,aAAa;IACb,aAAa;IACb,mBAAmB;IACnB,uBAAuB;EACzB;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,iBAAiB;EACnB;;EAEA;IACE,WAAW;IACX,YAAY;EACd;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,UAAU;IACV,8BAA8B;IAC9B,8BAA8B;EAChC;;EAEA;IACE,WAAW;IACX,YAAY;EACd;;EAEA;IACE,YAAY;IACZ,kBAAkB;IAClB,cAAc;EAChB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,WAAW;IACX,WAAW;IACX,kBAAkB;EACpB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,WAAW;IACX,aAAa;EACf;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,iBAAiB;EACnB;;EAEA;IACE,eAAe;EACjB;;AAEF;;;;;;;;;;;;;;AAcA;;EAEE;IACE,eAAe;EACjB;;EAEA;IACE,WAAW;IACX,WAAW;IACX,eAAe;EACjB;;EAEA;IACE,eAAe;IACf,iBAAiB;IACjB,qBAAqB;EACvB;;EAEA,6EAA6E;;EAE7E;IACE,WAAW;IACX,YAAY;IACZ,qBAAqB;IACrB,sBAAsB;EACxB;;EAEA;IACE,WAAW;IACX,YAAY;EACd;;EAEA;IACE,YAAY;IACZ,aAAa;EACf;;EAEA;IACE,uBAAuB;IACvB,wBAAwB;EAC1B;;EAEA;IACE,WAAW;IACX,YAAY;EACd;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,qBAAqB;IACrB,8BAA8B;IAC9B,sBAAsB;EACxB;;EAEA;IACE,WAAW;IACX,YAAY;EACd;;EAEA;IACE,YAAY;IACZ,yBAAyB;IACzB,cAAc;EAChB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,WAAW;IACX,WAAW;IACX,kBAAkB;EACpB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,WAAW;IACX,aAAa;IACb,aAAa;IACb,mBAAmB;IACnB,uBAAuB;EACzB;;EAEA;IACE,WAAW;IACX,aAAa;IACb,iBAAiB;EACnB;;EAEA;IACE,WAAW;IACX,YAAY;EACd;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,UAAU;IACV,8BAA8B;IAC9B,8BAA8B;EAChC;;EAEA;IACE,WAAW;IACX,YAAY;EACd;;EAEA;IACE,YAAY;IACZ,yBAAyB;IACzB,cAAc;EAChB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,WAAW;IACX,WAAW;IACX,kBAAkB;EACpB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,WAAW;IACX,aAAa;EACf;;EAEA;IACE,WAAW;IACX,aAAa;IACb,iBAAiB;EACnB;;EAEA;IACE,eAAe;EACjB;;AAEF;;;;;;;;;;;;;AAaA;;EAEE;IACE,eAAe;EACjB;;EAEA;IACE,WAAW;IACX,WAAW;IACX,eAAe;EACjB;;EAEA;IACE,eAAe;IACf,iBAAiB;IACjB,qBAAqB;EACvB;;EAEA,6EAA6E;;EAE7E;IACE,WAAW;IACX,YAAY;IACZ,qBAAqB;IACrB,sBAAsB;EACxB;;EAEA;IACE,WAAW;IACX,YAAY;EACd;;EAEA;IACE,YAAY;IACZ,yBAAyB;EAC3B;;EAEA;IACE,uBAAuB;IACvB,wBAAwB;EAC1B;;EAEA;IACE,WAAW;IACX,YAAY;EACd;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,qBAAqB;IACrB,8BAA8B;IAC9B,sBAAsB;EACxB;;EAEA;IACE,WAAW;IACX,YAAY;EACd;;EAEA;IACE,YAAY;IACZ,yBAAyB;IACzB,cAAc;EAChB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,WAAW;IACX,WAAW;IACX,kBAAkB;EACpB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,WAAW;IACX,aAAa;IACb,aAAa;IACb,mBAAmB;IACnB,uBAAuB;EACzB;;EAEA;IACE,WAAW;IACX,aAAa;IACb,iBAAiB;EACnB;;EAEA;IACE,WAAW;IACX,YAAY;EACd;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,UAAU;IACV,8BAA8B;IAC9B,8BAA8B;EAChC;;EAEA;IACE,WAAW;IACX,YAAY;EACd;;EAEA;IACE,YAAY;IACZ,yBAAyB;IACzB,cAAc;EAChB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,WAAW;IACX,WAAW;IACX,kBAAkB;EACpB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,WAAW;IACX,aAAa;EACf;;EAEA;IACE,WAAW;IACX,aAAa;IACb,iBAAiB;EACnB;;EAEA;IACE,eAAe;EACjB;;AAEF","sourcesContent":["@font-face {\n  font-family: regularThicker;\n  src: url(../../assets/fonts/Thicker-Regular.otf);\n}\n\n@font-face {\n  font-family: lightThicker;\n  src: url(../../assets/fonts/Thicker-Extralight.otf);\n}\n\n\n.about_wrapper {\n  width: 100%;\n  position: relative;\n}\n\n.about_main_div {\n  width: 100%;\n  background-color: #fff !important;\n}\n\n.about_info_main_div {\n  max-width: 100%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.about_info_div {\n  width: 100%;\n  padding: 0 80px;\n}\n\n.about_info_div > p {\n  color: #000;\n  font-family: regularThicker;\n  font-size: 20px;\n  font-style: normal;\n  font-weight: 400;\n  line-height: 150%;\n  margin: 30px 0 45px 0;\n}\n\n/* card styling start here ------------------------------------------------ */\n\n.about_logo_card_div {\n  width: 100%;\n  height: 100%;\n  background: #262626;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  position: sticky;\n  top: 0;\n}\n\n.about_logo_card {\n  width: 1443px;\n  height: 600px;\n  padding: 0 80px !important;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  flex-direction: row;\n}\n\n.about_logo_card_left {\n  width: 50%;\n  height: 100%;\n}\n\n.about_logo_card_left_inner {\n  height: 100%;\n  padding: 0px 40px 0px 0;\n  display: flex;\n  /* align-items: center; */\n  justify-content: center;\n  flex-direction: column;\n  overflow: auto;\n}\n\n.about_card_div {\n  width: 100%;\n  height: 100%;\n  background: #262626;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  position: sticky;\n  top: 0;\n}\n\n.about_card {\n  width: 1443px;\n  height: 600px;\n  padding: 0 80px !important;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  flex-direction: row;\n}\n\n.about_card_left {\n  width: 50%;\n  height: 100%;\n}\n\n.about_card_left_inner {\n  height: 100%;\n  padding: 0px 40px 0px 0;\n  display: flex;\n  justify-content: center;\n  flex-direction: column;\n  overflow: auto;\n}\n\n.about_card_left_heading {\n  color: #fff;\n  font-family: regularThicker;\n  font-size: 32px;\n  font-style: normal;\n  font-weight: 600;\n  line-height: 126.6%; /* 40.512px */\n  margin: 0 0 6px 0 !important;\n}\n\n.about_card_heading_border {\n  width: 114px;\n  height: 4px;\n  background: #ba1e24;\n  margin: 0 0 16px 0;\n}\n\n.about_card_left_para {\n  color: #fff;\n  font-family: lightThicker !important;\n  font-size: 20px;\n  font-style: normal;\n  font-weight: 400;\n  line-height: 150%; /* 27px */\n}\n\n.about_card_right {\n  width: 50%;\n  height: 100%;\n}\n\n.about_card_right > img {\n  width: 100%;\n  height: 100%;\n  object-fit: fill;\n}\n\n.about_card_div2 {\n  width: 100%;\n  height: 100%;\n  background: white;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  position: sticky;\n  top: 0;\n}\n\n.about_card2 {\n  width: 1443px;\n  height: 600px;\n  padding: 0 80px;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  flex-direction: row;\n}\n\n.about_card_left2 {\n  width: 50%;\n  height: 100%;\n}\n\n.about_card_left_inner2 {\n  height: 100%;\n  padding-left: 70px;\n  display: flex;\n  justify-content: center;\n  flex-direction: column;\n}\n\n.about_card_left_heading2 {\n  color: #000;\n  font-family: regularThicker;\n  font-size: 32px;\n  font-style: normal;\n  font-weight: 600;\n  line-height: 126.6%;\n  margin: 0 0 6px 0 !important;\n}\n\n.about_card_heading_border2 {\n  width: 114px;\n  height: 4px;\n  background: #ba1e24;\n  margin: 0 0 16px 0;\n}\n\n.about_card_left_para2 {\n  color: #000;\n  font-family: lightThicker !important;\n  font-size: 20px;\n  font-style: normal;\n  font-weight: 400;\n  line-height: 150%; /* 27px */\n}\n\n.about_card_right2 {\n  width: 50%;\n  height: 100%;\n}\n\n.about_card_right2 > img {\n  width: 100%;\n  height: 100%;\n  object-fit: fill;\n}\n\n.about_card_link {\n  color: #ba1e24;\n  font-family: regularThicker;\n  font-size: 18px;\n  font-style: normal;\n  font-weight: 400;\n  line-height: 150%;\n}\n\n.about_card_show_more_btn {\n  color: #ba1e24;\n  font-family: regularThicker;\n  font-size: 18px;\n  font-style: normal;\n  font-weight: 600;\n  /* line-height: 150%; */\n  background: none;\n  border: none;\n  margin-left: 5px;\n  cursor: pointer;\n}\n\n\n\n\n\n\n@media screen and (max-width: 1200px) {\n\n  .about_info_main_div {\n    max-width: 100%;\n  }\n\n  .about_info_div {\n    width: 100%;\n    width: 100%;\n    padding: 0 50px;\n  }\n\n  .about_info_div > p {\n    font-size: 20px;\n    margin: 30px 0 30px 0;\n  }\n\n  /* card styling start here ------------------------------------------------ */\n  \n  .about_logo_card {\n    width: 100%;\n    height: 500px;\n    padding: 0 50px !important;\n  }\n  \n  .about_logo_card_left {\n    width: 50%;\n    height: 100%;\n  }\n  \n  .about_logo_card_left_inner {\n    height: 100%;\n    padding: 0px 30px 0px 0;\n  }\n\n\n  .about_card_div {\n    width: 100%;\n    height: 100%;\n  }\n\n  .about_card {\n    width: 100%;\n    height: 500px;\n    padding: 0 !important;\n    justify-content: space-between;\n    flex-direction: row;\n  }\n\n  .about_card_left {\n    width: 50%;\n    height: 100%;\n  }\n\n  .about_card_left_inner {\n    padding: 50px 20px;\n    height: 100% !important;\n    justify-content: flex-start;\n  }\n\n  .about_card_left_heading {\n    font-size: 30px;\n    margin: 0 0 6px 0 !important;\n  }\n\n  .about_card_heading_border {\n    width: 100px;\n    height: 4px;\n    margin: 10px 0 10px 0;\n  }\n\n  .about_card_left_para {\n    font-size: 18px;\n  }\n\n  .about_card_right {\n    width: 50%;\n    height: 100%;\n  }\n\n  .about_card_right > img {\n    width: 100%;\n    height: 100%;\n    object-fit: cover;\n  }\n\n  .about_card_div2 {\n    width: 100%;\n    height: 100%;\n  }\n\n  .about_card2 {\n    width: 100%;\n    height: 500px;\n    padding: 0;\n    justify-content: space-between;\n    flex-direction: row;\n  }\n\n  .about_card_left2 {\n    width: 50%;\n    height: 100%;\n  }\n\n  .about_card_left_inner2 {\n    padding: 50px 20px;\n    justify-content: flex-start;\n  }\n\n  .about_card_left_heading2 {\n    font-size: 30px;\n    margin: 0 0 6px 0 !important;\n\n  }\n\n  .about_card_heading_border2 {\n    width: 100px;\n    height: 4px;\n    margin: 0 0 10px 0;\n  }\n\n  .about_card_left_para2 {\n    font-size: 18px;\n  }\n\n  .about_card_right2 {\n    width: 50%;\n    height: 100%;\n  }\n\n  .about_card_right2 > img {\n    width: 100%;\n    height: 100%;\n    object-fit: cover;\n  }\n\n  .about_card_link {\n    font-size: 16px;\n  }\n\n}\n\n\n\n\n\n\n\n\n\n@media screen and (max-width: 1024px) {\n\n  .about_info_main_div {\n    max-width: 100%;\n  }\n\n  .about_info_div {\n    width: 100%;\n    width: 100%;\n    padding: 0 40px;\n  }\n\n  .about_info_div > p {\n    font-size: 20px;\n    line-height: 26px;\n    margin: 30px 0 30px 0;\n  }\n\n  /* card styling start here ------------------------------------------------ */\n\n  .about_logo_card {\n    width: 100%;\n    height: 400px;\n    padding: 0 50px !important;\n  }\n  \n  .about_logo_card_left {\n    width: 50%;\n    height: 100%;\n  }\n  \n  .about_logo_card_left_inner {\n    height: 100%;\n    padding: 0px 20px 0px 0;\n  }\n\n  .about_card_div {\n    width: 100%;\n    height: 100%;\n  }\n\n  .about_card {\n    width: 100%;\n    height: 400px;\n    padding: 0 !important;\n    justify-content: space-between;\n    flex-direction: row;\n  }\n\n  .about_card_left {\n    width: 50%;\n    height: 100%;\n  }\n\n  .about_card_left_inner {\n    height: 100%;\n    padding: 40px 20px;\n    overflow: auto;\n  }\n\n  .about_card_left_heading {\n    font-size: 26px;\n  }\n\n  .about_card_heading_border {\n    width: 80px;\n    height: 4px;\n    margin: 0 0 10px 0;\n  }\n\n  .about_card_left_para {\n    font-size: 16px;\n  }\n\n  .about_card_right {\n    width: 50%;\n    height: 100%;\n  }\n\n  .about_card_right > img {\n    width: 100%;\n    height: 100%;\n    object-fit: cover;\n  }\n\n  .about_card_div2 {\n    width: 100%;\n    height: 100%;\n  }\n\n  .about_card2 {\n    width: 100%;\n    height: 400px;\n    padding: 0;\n    justify-content: space-between;\n    flex-direction: row;\n  }\n\n  .about_card_left2 {\n    width: 50%;\n    height: 100%;\n  }\n\n  .about_card_left_inner2 {\n    height: 100%;\n    padding: 40px 20px;\n    overflow: auto;\n  }\n\n  .about_card_left_heading2 {\n    font-size: 26px;\n  }\n\n  .about_card_heading_border2 {\n    width: 80px;\n    height: 4px;\n    margin: 0 0 10px 0;\n  }\n\n  .about_card_left_para2 {\n    font-size: 16px;\n  }\n\n  .about_card_right2 {\n    width: 50%;\n    height: 100%;\n  }\n\n  .about_card_right2 > img {\n    width: 100%;\n    height: 100%;\n    object-fit: cover;\n  }\n\n  .about_card_link {\n    font-size: 16px;\n  }\n\n}\n\n\n\n\n\n\n\n\n\n\n\n\n\n@media screen and (max-width: 800px) {\n\n  .about_info_main_div {\n    max-width: 100%;\n  }\n\n  .about_info_div {\n    width: 100%;\n    width: 100%;\n    padding: 0 30px;\n  }\n\n  .about_info_div > p {\n    font-size: 20px;\n    line-height: 26px;\n    margin: 20px 0 20px 0;\n  }\n\n  /* card styling start here ------------------------------------------------ */\n\n  .about_logo_card {\n    width: 100%;\n    height: 100%;\n    padding: 0 0 0 30px !important;\n    flex-direction: column;\n  }\n  \n  .about_logo_card_left {\n    width: 100%;\n    height: 100%;\n  }\n  \n  .about_logo_card_left_inner {\n    height: 100%;\n    padding: 20px;\n  }\n\n  .about_card_logo_img {\n    width: 500px !important;\n    height: 500px !important;\n  }\n\n  .about_card_div {\n    width: 100%;\n    height: 100%;\n  }\n\n  .about_card {\n    width: 100%;\n    height: 100%;\n    padding: 0 !important;\n    justify-content: space-between;\n    flex-direction: column;\n  }\n\n  .about_card_left {\n    width: 100%;\n    height: 100%;\n  }\n\n  .about_card_left_inner {\n    height: 100%;\n    padding: 40px 20px;\n    overflow: auto;\n  }\n\n  .about_card_left_heading {\n    font-size: 26px;\n  }\n\n  .about_card_heading_border {\n    width: 80px;\n    height: 4px;\n    margin: 0 0 10px 0;\n  }\n\n  .about_card_left_para {\n    font-size: 16px;\n  }\n\n  .about_card_right {\n    width: 100%;\n    height: 500px;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n  }\n\n  .about_card_right > img {\n    width: 100%;\n    height: 100%;\n    object-fit: cover;\n  }\n\n  .about_card_div2 {\n    width: 100%;\n    height: 100%;\n  }\n\n  .about_card2 {\n    width: 100%;\n    height: 100%;\n    padding: 0;\n    justify-content: space-between;\n    flex-direction: column-reverse;\n  }\n\n  .about_card_left2 {\n    width: 100%;\n    height: 100%;\n  }\n\n  .about_card_left_inner2 {\n    height: 100%;\n    padding: 40px 20px;\n    overflow: auto;\n  }\n\n  .about_card_left_heading2 {\n    font-size: 26px;\n  }\n\n  .about_card_heading_border2 {\n    width: 80px;\n    height: 4px;\n    margin: 0 0 10px 0;\n  }\n\n  .about_card_left_para2 {\n    font-size: 16px;\n  }\n\n  .about_card_right2 {\n    width: 100%;\n    height: 500px;\n  }\n\n  .about_card_right2 > img {\n    width: 100%;\n    height: 100%;\n    object-fit: cover;\n  }\n\n  .about_card_link {\n    font-size: 16px;\n  }\n\n}\n\n\n\n\n\n\n\n\n\n\n\n\n\n@media screen and (max-width: 600px) {\n\n  .about_info_main_div {\n    max-width: 100%;\n  }\n\n  .about_info_div {\n    width: 100%;\n    width: 100%;\n    padding: 0 20px;\n  }\n\n  .about_info_div > p {\n    font-size: 16px;\n    line-height: 22px;\n    margin: 20px 0 20px 0;\n  }\n\n  /* card styling start here ------------------------------------------------ */\n\n  .about_logo_card {\n    width: 100%;\n    height: 100%;\n    padding: 0 !important;\n    flex-direction: column;\n  }\n  \n  .about_logo_card_left {\n    width: 100%;\n    height: 100%;\n  }\n  \n  .about_logo_card_left_inner {\n    height: 100%;\n    padding: 20px;\n  }\n\n  .about_card_logo_img {\n    width: 400px !important;\n    height: 400px !important;\n  }\n\n  .about_card_div {\n    width: 100%;\n    height: 100%;\n  }\n\n  .about_card {\n    width: 100%;\n    height: 100%;\n    padding: 0 !important;\n    justify-content: space-between;\n    flex-direction: column;\n  }\n\n  .about_card_left {\n    width: 100%;\n    height: 100%;\n  }\n\n  .about_card_left_inner {\n    height: 100%;\n    padding: 40px 20px 0 20px;\n    overflow: auto;\n  }\n\n  .about_card_left_heading {\n    font-size: 26px;\n  }\n\n  .about_card_heading_border {\n    width: 80px;\n    height: 4px;\n    margin: 0 0 10px 0;\n  }\n\n  .about_card_left_para {\n    font-size: 16px;\n  }\n\n  .about_card_right {\n    width: 100%;\n    height: 400px;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n  }\n\n  .about_card_right > img {\n    width: 100%;\n    height: 400px;\n    object-fit: cover;\n  }\n\n  .about_card_div2 {\n    width: 100%;\n    height: 100%;\n  }\n\n  .about_card2 {\n    width: 100%;\n    height: 100%;\n    padding: 0;\n    justify-content: space-between;\n    flex-direction: column-reverse;\n  }\n\n  .about_card_left2 {\n    width: 100%;\n    height: 100%;\n  }\n\n  .about_card_left_inner2 {\n    height: 100%;\n    padding: 40px 20px 0 20px;\n    overflow: auto;\n  }\n\n  .about_card_left_heading2 {\n    font-size: 26px;\n  }\n\n  .about_card_heading_border2 {\n    width: 80px;\n    height: 4px;\n    margin: 0 0 10px 0;\n  }\n\n  .about_card_left_para2 {\n    font-size: 16px;\n  }\n\n  .about_card_right2 {\n    width: 100%;\n    height: 400px;\n  }\n\n  .about_card_right2 > img {\n    width: 100%;\n    height: 400px;\n    object-fit: cover;\n  }\n\n  .about_card_link {\n    font-size: 16px;\n  }\n\n}\n\n\n\n\n\n\n\n\n\n\n\n\n@media screen and (max-width: 450px) {\n\n  .about_info_main_div {\n    max-width: 100%;\n  }\n\n  .about_info_div {\n    width: 100%;\n    width: 100%;\n    padding: 0 16px;\n  }\n\n  .about_info_div > p {\n    font-size: 16px;\n    line-height: 22px;\n    margin: 20px 0 20px 0;\n  }\n\n  /* card styling start here ------------------------------------------------ */\n\n  .about_logo_card {\n    width: 100%;\n    height: 100%;\n    padding: 0 !important;\n    flex-direction: column;\n  }\n  \n  .about_logo_card_left {\n    width: 100%;\n    height: 100%;\n  }\n  \n  .about_logo_card_left_inner {\n    height: 100%;\n    padding: 20px 20px 0 20px;\n  }\n\n  .about_card_logo_img {\n    width: 400px !important;\n    height: 400px !important;\n  }\n\n  .about_card_div {\n    width: 100%;\n    height: 100%;\n  }\n\n  .about_card {\n    width: 100%;\n    height: 100%;\n    padding: 0 !important;\n    justify-content: space-between;\n    flex-direction: column;\n  }\n\n  .about_card_left {\n    width: 100%;\n    height: 100%;\n  }\n\n  .about_card_left_inner {\n    height: 100%;\n    padding: 40px 20px 0 20px;\n    overflow: auto;\n  }\n\n  .about_card_left_heading {\n    font-size: 26px;\n  }\n\n  .about_card_heading_border {\n    width: 80px;\n    height: 4px;\n    margin: 0 0 10px 0;\n  }\n\n  .about_card_left_para {\n    font-size: 16px;\n  }\n\n  .about_card_right {\n    width: 100%;\n    height: 350px;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n  }\n\n  .about_card_right > img {\n    width: 100%;\n    height: 350px;\n    object-fit: cover;\n  }\n\n  .about_card_div2 {\n    width: 100%;\n    height: 100%;\n  }\n\n  .about_card2 {\n    width: 100%;\n    height: 100%;\n    padding: 0;\n    justify-content: space-between;\n    flex-direction: column-reverse;\n  }\n\n  .about_card_left2 {\n    width: 100%;\n    height: 100%;\n  }\n\n  .about_card_left_inner2 {\n    height: 100%;\n    padding: 60px 20px 0 20px;\n    overflow: auto;\n  }\n\n  .about_card_left_heading2 {\n    font-size: 26px;\n  }\n\n  .about_card_heading_border2 {\n    width: 80px;\n    height: 4px;\n    margin: 0 0 10px 0;\n  }\n\n  .about_card_left_para2 {\n    font-size: 16px;\n  }\n\n  .about_card_right2 {\n    width: 100%;\n    height: 350px;\n  }\n\n  .about_card_right2 > img {\n    width: 100%;\n    height: 350px;\n    object-fit: cover;\n  }\n\n  .about_card_link {\n    font-size: 16px;\n  }\n\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
